import Button from '@doordash/component-button'
import { Modal } from '@doordash/component-modal'
import * as React from 'react'
import { FormRefProps, nccShareModalStepConfig, NccShareSteps } from './config'

interface NccBackgroundCheckShareModalProps {
  onClose: (isSubmitted: boolean) => void
}

const getModalConfig = (step: NccShareSteps) => {
  return nccShareModalStepConfig[step]
}

const NccBackgroundCheckShareModal: React.FC<NccBackgroundCheckShareModalProps> = ({
  onClose,
}) => {
  const [shareStep, setShareStep] = React.useState(NccShareSteps.Start)
  const [isSubmitted, setIsSubmitted] = React.useState(false)
  const formRef = React.useRef<FormRefProps>({ form: null, isValid: false })

  const {
    title,
    subtitle,
    primaryButtonText,
    secondaryButtonText,
    renderContent,
    hasFormRef,
  } = getModalConfig(shareStep)

  const isFirstStep = shareStep === NccShareSteps.Start
  const isLastStep = shareStep === NccShareSteps.Complete

  const handlePrimaryClick = () => {
    if (hasFormRef) {
      formRef.current.form.dispatchEvent(
        new Event('submit', { cancelable: true })
      )
      if (!formRef.current.isValid) {
        return
      }
      setIsSubmitted(true)
    }
    if (isLastStep) {
      // TODO @sujay-gandham-dd: if check share submitted, reload page on close to show progress screen
      onClose(isSubmitted)
      return
    }

    setShareStep(shareStep + 1)
  }

  const handleSecondaryClick = () => {
    if (isFirstStep) {
      onClose(isSubmitted)
      return
    }

    setShareStep(shareStep - 1)
  }

  return (
    <Modal
      onClose={onClose}
      size={Modal.Sizes.Medium}
      isFullScreenOnMobile
      title={title}
      subtitle={subtitle}
      shouldRenderStickyHeader={false}
      closeButtonSide={Modal.CloseButtonSides.Leading}
      primaryAction={
        primaryButtonText
          ? {
              text: primaryButtonText,
              onClick: handlePrimaryClick,
            }
          : null
      }
      secondaryAction={
        secondaryButtonText
          ? {
              text: secondaryButtonText,
              buttonProps: {
                type: Button.Types.FlatSecondary,
              },
              onClick: handleSecondaryClick,
            }
          : null
      }
      useHairlineDividers
    >
      {hasFormRef && typeof renderContent === 'function'
        ? renderContent(formRef)
        : renderContent}
    </Modal>
  )
}

export default NccBackgroundCheckShareModal
